import cloneDeep from 'lodash.clonedeep';
var TableElement = /** @class */ (function () {
    function TableElement(init) {
        Object.assign(this, init);
    }
    TableElement.prototype.delete = function () {
        this.source.delete(this.id);
    };
    TableElement.prototype.confirmEditCreate = function () {
        if (this.id === -1) {
            return this.source.confirmCreate(this);
        }
        else {
            return this.source.confirmEdit(this);
        }
    };
    TableElement.prototype.startEdit = function () {
        this.originalData = cloneDeep(this.currentData);
        this.editing = true;
        this.validator.enable();
    };
    TableElement.prototype.cancelOrDelete = function () {
        if (this.id === -1 || !this.editing) {
            this.delete();
        }
        else {
            this.currentData = this.originalData;
            this.editing = false;
            this.validator.disable();
        }
    };
    Object.defineProperty(TableElement.prototype, "shouldCreate", {
        get: function () {
            return this.id === -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableElement.prototype, "shouldDelete", {
        get: function () {
            return this.id === -1 || !this.editing;
        },
        enumerable: true,
        configurable: true
    });
    return TableElement;
}());
export { TableElement };
